import { Button } from "@/components/ui/button";

interface DashboardTopBarProps {
  onSignOut: () => void;
  signingOut: boolean;
}

export function DashboardTopBar({ onSignOut, signingOut }: DashboardTopBarProps) {
  return (
    <header className="flex items-center justify-between border-b border-op-border px-4 py-3 md:px-6">
      <div className="flex items-baseline gap-3">
        <span className="font-serif text-xl tracking-tight text-op-primary">
          Oprentis
        </span>
        <span className="text-[10px] uppercase tracking-[0.18em] text-op-secondary">
          Mail Assistant
        </span>
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={onSignOut}
        disabled={signingOut}
        data-testid="sign-out-button"
      >
        {signingOut ? "Signing out…" : "Sign out"}
      </Button>
    </header>
  );
}
